import React from 'react';

export const NameResultSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 animate-pulse">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="h-8 bg-gray-200 rounded w-2/3"></div>
        <div className="h-6 bg-gray-200 rounded-full w-20"></div>
      </div>

      {/* Scores */}
      <div className="flex gap-4 mb-4">
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 bg-gray-200 rounded-full mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-16"></div>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 bg-gray-200 rounded-full mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-16"></div>
        </div>
      </div>

      {/* Slogan */}
      <div className="mb-4">
        <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-4/5"></div>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
        <div className="h-6 bg-gray-200 rounded w-16"></div>
        <div className="h-6 bg-gray-200 rounded w-20"></div>
        <div className="h-6 bg-gray-200 rounded w-24"></div>
      </div>
    </div>
  );
};

interface NameResultSkeletonGridProps {
  count?: number;
}

export const NameResultSkeletonGrid: React.FC<NameResultSkeletonGridProps> = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {Array.from({ length: count }).map((_, idx) => (
        <NameResultSkeleton key={idx} />
      ))}
    </div>
  );
};

